const cgu_scopes = {
    CURRENT_CGU : 'cgu:cgu:current',
    CURRENT_DOC : 'cgu:documents:current'
};

export default cgu_scopes;
